<template>
    <CContainer class="p-0">
        <CRow alignVertical="center">
            <CCol md="12" sm="12">
                <h5>
                    {{ $t("Webhook type") }}
                </h5>
                <p class="mb-1">
                    {{
                        $t("Select the type of shipments you want to capture.")
                    }}
                </p>
                <CSelect
                    size="sm"
                    :value.sync="$v.settings.type.$model"
                    :options="webhookTypes"
                    :placeholder="$t('Select a type')"
                    :isValid="
                        checkIfSettingsValid({
                            fieldName: 'type',
                        })
                    "
                    :disabled="view_type == 'edit'"
                />
            </CCol>
        </CRow>
    </CContainer>
</template>

<script>
import baseMixin from "~/mixins/base.js";
import { validationMixin } from "vuelidate";
import { required } from "vuelidate/lib/validators";

import SelectAsync from "£lement/SelectAsync";
import ButtonSave from "~/components/ButtonSave.vue";

export default {
    name: "BrevoSettings",
    mixins: [baseMixin, validationMixin],
    components: {
        SelectAsync,
        ButtonSave,
    },
    data() {
        return {
            settings: {
                type: null,
            },
            webhookTypes: [],
        };
    },
    validations: {
        settings: {
            type: {
                required,
            },
        },
    },
    props: {
        plugin_marketing_credentials_uuid: {
            required: true,
        },
        view_type: {
            required: true,
        },
        value: {
            default: () => ({
                type: null,
            }),
            required: true,
        },
    },
    watch: {
        async value(newValue) {
            await this.assingValues(newValue);
        },
        "settings.type": {
            handler(newValue) {
                const updateValue = {
                    ...this.value,
                    type: newValue,
                };
                this.$emit("update:value", updateValue);
                this.$emit("change", updateValue);
            },
            deep: true,
        },
    },
    methods: {
        async assingValues(newValue) {
            if (newValue.type != undefined) this.settings.type = newValue.type;
        },
        async loadWebhookTypes() {
            this.webhookTypes = {
                marketing: "marketing",
                transactional: "transactional",
            };
        },
        validateSettings() {
            let valForm = this.$v.settings;
            if (!valForm) return false;
            valForm.$touch();
            return !valForm.$invalid;
        },
        checkIfSettingsValid({ fieldName }) {
            const field = this.$v.settings[fieldName];
            if (!field.$dirty) {
                return null;
            }
            return !(field.$invalid || field.$model === "");
        },
    },
    async mounted() {
        await this.assingValues(this.value);
    },
    async created() {
        await this.loadWebhookTypes();
    },
};
</script>

<style></style>
